/* eslint-disable no-empty-pattern */
/* eslint no-param-reassign: 0 */
import { PlayService } from '../services/play.service';

const playState = {
  config: {},
  lvspConfig: {},
};

const mutations = {
  setConfig(state, config) {
    state.config = config;
  },
  setLVSPConfig(state, config) {
    state.lvspConfig = config;
  }
};

const getters = {
  config: state => state.config,
  lvspConfig: state => state.lvspConfig,
};

const actions = {
  getConfig: async ({ commit }) => {
    try {
      const config = await PlayService.getConfig();
      commit('setConfig', config);
    } catch (e) { /* Do nothing */ }
  },
  updateConfig: async ({}, payload) => {
    try {
      await PlayService.updateConfig(payload);
      return true;
    } catch (e) { return false; }
  },
  updateLogo: async ({}, image) => {
    try {
      await PlayService.uploadLogo(image);
      return true;
    } catch (e) { return false; }
  },
  updateDefaultPoster: async ({}, image) => {
    try {
      await PlayService.uploadDefaultPoster(image);
      return true;
    } catch (e) { return false; }
  },
  getLVSPConfig: async ({ commit }) => {
    try {
      const config = await PlayService.getLVSPConfig();
      commit('setLVSPConfig', config);
      return true;
    } catch (e) { /* Do nothing */ }
  },
  updateLVSPConfig: async ({}, payload) => {
    try {
      const result = await PlayService.updateLVSPConfig(payload);
      return result;
    } catch (e) {
      return e;
    }
  },
};

export default {
  namespaced: true,
  state: playState,
  mutations,
  getters,
  actions,
};
